import type { ReactNode } from 'react'

import { useCallsDialogContext } from '@src/app/voice/context/useCallsDialogContext'
import IconButton from '@src/component/IconButton'
import { theme } from '@ui/theme'

const EndButton = ({
  title,
  icon,
  handleDisconnect,
  className,
}: {
  title: string
  icon: ReactNode
  handleDisconnect: () => void
  className?: string
}) => {
  const { blurred } = useCallsDialogContext()

  return (
    // eslint-disable-next-line custom-rules/no-deprecated-buttons, @typescript-eslint/no-deprecated -- FIXME: https://linear.app/openphone/issue/UXP-4347/migrate-deprecated-buttons-to-ds-button
    <IconButton
      icon={icon}
      title={title}
      color={'white'}
      backgroundColor={
        blurred
          ? `rgb(${theme.palette.overlay.strong})`
          : `rgb(${theme.palette.secondary.red.default})`
      }
      size={34}
      className={className}
      tooltip={{
        themeKey: 'dark',
        colorScheme: 'call',
        placement: 'top',
      }}
      onClick={handleDisconnect}
    />
  )
}

export default EndButton
